import React from 'react'
import PropTypes from 'prop-types'
import { Link, withRouter } from 'react-router-dom'
import cx from 'classnames'
import links from './links'
import './styles.css'

const NavMenu = ({ location }) => (
  <nav className={cx('app-nav')}>
    <ul className={cx('app-nav-list')}>
      {links.map(link => (
        <li key={link.linkID}>
          <Link
            className={cx('app-nav-link', { 'is-active': link.linkRoute === location.pathname })}
            to={link.linkRoute}
          >
            {link.linkName}
          </Link>
        </li>
      ))}
    </ul>
  </nav>
)


NavMenu.propTypes = {
  location: PropTypes.object.isRequired,
}

export default withRouter(props => <NavMenu {...props} />)



// WEBPACK FOOTER //
// ./src/client/components/navMenu/index.js